import styled from 'styled-components';
import { Wrapper } from '../../Wrapper/Wrapper';
import { Theme } from '../../../../theme/theme';
import { BorderProps } from '../../../../theme/styledProps';

interface Props extends BorderProps {
  isActive: boolean;
  theme: Theme;
}

export const Accordion = styled(Wrapper)(({ isActive, theme, borderRadius }: Props) => ({
  borderRadius: borderRadius ?? theme.radii.xl,
  border: `1px solid ${theme.colors.neutral['200']}`,
  boxShadow: isActive ? theme.shadows['300'] : 'none',
  background: theme.colors.bg,
}));
